export const srcSet="__VITE_ASSET__4uKGgEnV__ 240w";export const width=240;export const height=320;export default{srcSet:srcSet,width:width,height:height};